// extracted by mini-css-extract-plugin
module.exports = {"events":"EventsList_events__1q0cU","list":"EventsList_list__3MUa_","item":"EventsList_item__3ugr1","event":"EventsList_event__2xFPF"};